import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MsalService } from '@azure/msal-angular';
import { RouterLink, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';
import { MaintenanceService, LoginNoticeItem } from '../../services/maintenance.service';

@Component({
  selector: 'app-login-sso',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-sso.component.html',
  styleUrls: ['./login-sso.component.css']
})

export class LoginSsoComponent implements OnInit {
   title = 'login';
    submitted = false;
    errorMessage: string = '';
    successMessage: string = '';
    logInMsg: any;
    isText: boolean = false;
    eyeIcon: string = "bi-eye-slash";
    type: string = "password";
    isSelected: any;
    buttonText: any;
    lang: any;
    termsAgreed: any;
    privecy: any;
    rolePermitted: any[] = ['Admin', 'Manager', 'Rep'];

  // メンテナンス状態
  isSuspended: boolean = false;
  suspendStartDate: string | null = null;
  suspendEndDate: string | null = null;
  notices: LoginNoticeItem[] = [];
  private adminBypassMode: boolean = false;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.isSuspended && event.key === '*') {
      this.adminBypassMode = true;
      this.proceedWithSso();
    }
  }

  constructor(private msalService: MsalService, private router: Router, private auth: AuthService, private user: UserService, private maintenanceSvc: MaintenanceService) {
    this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'jp');
    console.log(this.lang);
    return
  }
  email:string = '';

  async ngOnInit(): Promise<void> {
    // 1. まずメンテナンス状態を確認し、停止中なら画面表示のみ行う
    this.maintenanceSvc.getLoginMaintenanceStatus().subscribe(async (status) => {
      this.isSuspended = status.isSuspended;
      this.suspendStartDate = status.suspendStartDate;
      this.suspendEndDate = status.suspendEndDate;
      this.notices = status.notices;

      if (!this.isSuspended) {
        await this.proceedWithSso();
      }
      // isSuspended = true の場合はキー入力待ち（onKeyDown で処理）
    });
  }

  async proceedWithSso(): Promise<void> {
    const account = await this.msalService.instance.getActiveAccount();
    console.log('MSAL SSO Component Initialized');
    if (account) {
      console.log('User logged in:', account);
      this.email = account.username;
      console.log('Logged in as:', this.email);
      /*******call external login */
      if (environment.useNewSsoLoginEndpoint) {
        // NEW: 1 API call (external-sso-authenticate-with-profile)
        // Rollback: set useNewSsoLoginEndpoint = false in environment files
        const loginObservable = await this.auth.loginSsoWithProfile(this.lang);
        loginObservable?.subscribe({
          next: (res: any) => {
            if (res.status) {
              const profile = res.data.user;
              // adminBypassMode 時は adminLevel>1 のみ通過（トークン未保存で静かに戻す）
              if (this.adminBypassMode && profile.adminLevel < 2) {
                this.adminBypassMode = false;
                return;
              }
              // adminLevel 1 はアクセス不可（トークンを削除して静かに戻す）
              if (profile.adminLevel === 1) {
                this.router.navigate(['/no-access']);
                return;
              }
              this.auth.storeToken(res.data.token);
              this.errorMessage = '';
              this.successMessage = res.message;
              localStorage.setItem('site_lang', this.lang);
              this.auth.storeCode(profile.userCode);
              this.auth.storeName(profile.userName);
              this.auth.storeLoginId(profile.loginId);
              this.auth.storeRole(profile.userRole);
              this.auth.storeType(profile.userType);
              this.auth.storeAdminLevel(profile.adminLevel);
              this.auth.storeReadWrite(profile.readWrite);
              this.auth.storeEmail(profile.email2);
              this.auth.storeCompanyName(profile.companyName);
              // UserIDを保存
              if (profile.userId !== undefined && profile.userId !== null) {
                this.auth.storeUserId(profile.userId);
              } else if (profile.userID !== undefined && profile.userID !== null) {
                this.auth.storeUserId(profile.userID);
              }
              if (profile.noticeEmail) {
                this.termsAgreed = 'yes';
              } else {
                this.termsAgreed = 'no';
              }
              if (profile.privacy) {
                this.privecy = 'yes';
              } else {
                this.privecy = 'no';
              }
              this.auth.storeNotice(this.termsAgreed);
              this.auth.storePrivecy(this.privecy);
              if (this.privecy == 'yes') {
                if (profile.userRole == 'Client') {
                  this.router.navigate(['client-associatelist'], { state: { consent: this.termsAgreed } });
                  return;
                } else if (profile.userRole == 'Staff') {
                  this.router.navigate(['home'], { state: { consent: this.termsAgreed } });
                  return;
                }
                if (profile.userRole == 'Admin' || profile.userRole == 'Rep') {
                  if (profile.userType == 'C') {
                    if (profile.userRole == 'Admin') {
                      this.router.navigate(['admin-home']);
                    } else {
                      this.router.navigate(['representative-home']);
                    }
                  } else if (profile.userType == 'B' || profile.userType == 'D') {
                    this.router.navigate(['client-associatelist']);
                  } else if (profile.userType == 'A') {
                    this.router.navigate(['asc-report']);
                  }
                  return;
                } else if (profile.userRole == 'Manager') {
                  this.router.navigate(['manager-home']);
                  return;
                } else {
                  this.router.navigate(['no-access']);
                }
              } else {
                this.router.navigate(['privacy']);
              }
            } else {
              if (res.data?.isAuthenticated && res.data?.mustChangePassword) {
                return;
              } else {
                this.errorMessage = res.message;
                alert(res.message);
                this.router.navigate(['login']);
              }
            }
            this.submitted = false;
          },
          error: (err) => {
            alert(err.error.message);
            this.successMessage = '';
            this.errorMessage = err?.error.message;
          }
        });
      } else {
        // OLD: 2 API calls (external-sso-authenticate → /user/details)
        // This path is kept for rollback. Set useNewSsoLoginEndpoint = false to use.
        const loginObservable = await this.auth.loginSSO(this.lang);
        loginObservable?.subscribe({
        next: (res:any) => {
          // alert(res.message);
          if (res.status) {
            this.auth.storeToken(res.data.token);
            this.errorMessage = '';
            this.successMessage = res.message;
            // Get user profile data
            this.user.getUserProfile().subscribe({
              next: (res: any) => {
                if (res.status) {
                  // adminBypassMode 時は adminLevel>1 のみ通過（トークンを削除して静かに戻す）
                  if (this.adminBypassMode && res.data.adminLevel < 2) {
                    localStorage.removeItem('token');
                    this.adminBypassMode = false;
                    return;
                  }
                  // adminLevel 1 はアクセス不可（トークンを削除して静かに戻す）
                  if (res.data.adminLevel === 1) {
                    this.router.navigate(['no-access']);
                    return;
                  }
                  localStorage.setItem('site_lang', this.lang);
                // console.log(localStorage.getItem('site_lang'));
                // this.translate.use(lang);
                  this.auth.storeCode(res.data.userCode);
                  this.auth.storeName(res.data.userName);
                  this.auth.storeLoginId(res.data.loginId);
                  this.auth.storeRole(res.data.userRole);
                  this.auth.storeType(res.data.userType);
                  this.auth.storeAdminLevel(res.data.adminLevel);
                  this.auth.storeReadWrite(res.data.readWrite);
                  this.auth.storeEmail(res.data.email2);
                  this.auth.storeCompanyName(res.data.companyName);
                  // UserIDを保存
                  if (res.data.userId !== undefined && res.data.userId !== null) {
                    this.auth.storeUserId(res.data.userId);
                  } else if (res.data.userID !== undefined && res.data.userID !== null) {
                    this.auth.storeUserId(res.data.userID);
                  }
                  if (res.data.noticeEmail) {
                    this.termsAgreed = 'yes';
                  } else {
                    this.termsAgreed = 'no';
                  }
                  
                  if (res.data.privacy) {
                    this.privecy = 'yes';
                  } else {
                    this.privecy = 'no';
                  }
                  this.auth.storeNotice(this.termsAgreed);
                  this.auth.storePrivecy(this.privecy);
                  // console.log(res.data.userRole);
                  
                  if (this.privecy == "yes") {                  
                    if (res.data.userRole == 'Client') {
                      this.router.navigate(['client-associatelist'], { state: { consent: this.termsAgreed } });
                      return;
                    } else if(res.data.userRole == 'Staff') {  
                      this.router.navigate(['home'], { state: { consent: this.termsAgreed } });
                      return;
                    }
                      if (res.data.userRole == 'Admin' || res.data.userRole == 'Rep') {                    
                      // this.router.navigate(['admin-home']);
                      if (res.data.userType == 'C') {
                        if (res.data.userRole == 'Admin') {
                          this.router.navigate(['admin-home']);
                        } else {
                          this.router.navigate(['representative-home']);
                        }
                      } else if (res.data.userType == 'B' || res.data.userType == 'D') {
                        this.router.navigate(['client-associatelist']);
                      } else if (res.data.userType == 'A') {
                        this.router.navigate(['asc-report']);
                      }
                      return;
                    } else if (res.data.userRole == 'Manager') {
                      // this.router.navigate(['administrator-menu']);
                      this.router.navigate(['manager-home']);
                      return;
                      }
                        
                    // else if (res.data.userRole == 'Admin' || res.data.userRole == 'Rep' || res.data.userRole == 'Manager') {
                    //   // UserType に応じて初期画面を決定
                    //   if (res.data.userType == 'C') {
                    //     this.router.navigate(['manager-home']);
                    //   } else if (res.data.userType == 'B' || res.data.userType == 'D') {
                    //     this.router.navigate(['client-associatelist']);
                    //   } else if (res.data.userType == 'A') {
                    //     this.router.navigate(['asc-report']);
                    //   } else {
                    //     // UserTypeが設定されていない場合のフォールバック
                    //     this.router.navigate(['no-access']);
                    //   }
                    //   return;
                    //   }
                    else {
                      this.router.navigate(['no-access']);
                    }
                    
                  } else {
                    this.router.navigate(['privacy']);
                  }


                  // console.log(this.termsAgreed);
                  // this.auth.storeConsent(this.termsAgreed);
                } else {
                  console.log(res.message);
                  alert(res.message);
                  
                }
              },
              error: (err: any) => {
                // alert(err.error.message);
                console.log(err)
                // alert(err?.error.message);
                this.successMessage = '';
                this.errorMessage = err?.error.message;
              }
            });

          } else {
            if (res.data?.isAuthenticated && res.data?.mustChangePassword) {
              // alert("redirect")
              //this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password} });
              return;
            } else {

              this.errorMessage = res.message;
              alert(res.message);

              // console.log(res.message);
              
              this.router.navigate(['login']);
            }
          }
          this.submitted = false;
          // this.auth.storeName(res.data.Profile.FirstName + ' '+ res.data.Profile.LastName);
        },
        error: (err) => {        
          alert(err.error.message);        
          this.successMessage = '';
          this.errorMessage = err?.error.message;
        }
      });
      }
      
    }
    else {
      this.login();
      console.log('No user is logged in.');
    }
  }

  login() {
    this.msalService.loginRedirect();
  }
}
